import { LabeledField } from '@/components/LabeledField';
import {
  getEncounterReason,
  getMainPractitioner,
} from '@/utils/encounter.utils';
import { Paper, SimpleGrid } from '@mantine/core';
import { Encounter } from '@medplum/fhirtypes';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface ClinicalExaminationHeaderProps {
  encounter: Encounter;
}
export const ClinicalExaminationHeader: FC<ClinicalExaminationHeaderProps> = ({
  encounter,
}) => {
  const { t } = useTranslation(['encounters']);

  const reason = getEncounterReason(encounter);
  const doctor = getMainPractitioner(encounter);
  const type = encounter.type?.[0]?.coding?.[0]?.display;

  return (
    <Paper withBorder p="md" radius="md" bg="blue.0">
      <SimpleGrid cols={3}>
        <LabeledField label={t('type')} value={type} />
        <LabeledField
          label={t('practitioner', { ns: 'encounters' })}
          value={doctor?.display}
        />
        <LabeledField label={t('reason')} value={reason} />
      </SimpleGrid>
    </Paper>
  );
};
